import { Controller } from '@hotwired/stimulus'
// import PrimeVue from 'primevue/config'
import { createApp } from 'vue'
import ActualPeriod from '@/components/actual_period.vue'
import VueElementLoading from 'vue-element-loading'
import PrimeVue from 'primevue/config'
// import WorkHistory from '@/components/work_history.vue'
// import SelectButton from 'primevue/selectbutton'
// import axios from 'axios'
// import VueElementLoading from 'vue-element-loading'

export default class extends Controller {
  static targets = ['operations', 'checkbox']
  connect() {
    const app = createApp(ActualPeriod, {
      postCsvUrl: this.operationsTarget.dataset.postCsvUrl,
      creatorsUrl: this.operationsTarget.dataset.creatorsUrl,
      departmentId: Number(this.operationsTarget.dataset.departmentId),
      actualPeriodStartDate:
        this.operationsTarget.dataset.actualPeriodStartDate,
      actualPeriodId: this.operationsTarget.dataset.actualPeriodId,
      monthlyActualReports: JSON.parse(
        this.operationsTarget.dataset.monthlyActualReports
      )
    })
    app.use(PrimeVue, {
      locale: {
        accept: 'はい',
        reject: 'いいえ',
        choose: '選択',
        upload: 'アップロード',
        cancel: 'キャンセル',
        dayNames: [
          '日曜日',
          '月曜日',
          '火曜日',
          '水曜日',
          '木曜日',
          '金曜日',
          '土曜日'
        ],
        dayNamesShort: ['日', '月', '火', '水', '木', '金', '土'],
        dayNamesMin: ['日', '月', '火', '水', '木', '金', '土'],
        monthNames: [
          '1月',
          '2月',
          '3月',
          '4月',
          '5月',
          '6月',
          '7月',
          '8月',
          '9月',
          '10月',
          '11月',
          '12月'
        ],
        monthNamesShort: [
          '1月',
          '2月',
          '3月',
          '4月',
          '5月',
          '6月',
          '7月',
          '8月',
          '9月',
          '10月',
          '11月',
          '12月'
        ],
        today: '今日',
        clear: 'クリア',
        weekHeader: '週',
        firstDayOfWeek: 1,
        dateFormat: 'yy/mm/dd',
        weak: '弱い',
        medium: '普通',
        strong: '強い',
        passwordPrompt: 'パスワードを入力'
      }
    })
    app.component('VueElementLoading', VueElementLoading)
    app.mount(this.operationsTarget)
  }
  updateCheckedList() {
    const event = new CustomEvent('rowSelected')
    dispatchEvent(event) // vueでイベントリッスンしてます
  }
  headerChecked(event) {
    if (event.target.checked) {
      this.checkboxTargets.forEach((e) => {
        e.checked = true
      })
    } else {
      this.checkboxTargets.forEach((e) => {
        e.checked = false
      })
    }
    this.updateCheckedList()
  }
}
